import { Component, input, output } from '@angular/core';

import type { AggregatedEvaluationsQuestion } from '@core/evaluations-types';
import { AggregatedEvaluationsQuestionAggregateType } from '@core/evaluations-types';
import { Theme } from '@core/theme-util';
import { BoxComponent } from '@core/user-interface-legacy';

import { CandidateOfferEvaluationQuestionAttachmentsComponent } from './candidate-offer-evaluation-question-attachments/candidate-offer-evaluation-question-attachments.component';
import { CandidateOfferEvaluationQuestionBooleanDistributionComponent } from './candidate-offer-evaluation-question-boolean-distribution/candidate-offer-evaluation-question-boolean-distribution.component';
import { CandidateOfferEvaluationQuestionCommentsComponent } from './candidate-offer-evaluation-question-comments/candidate-offer-evaluation-question-comments.component';
import { CandidateOfferEvaluationQuestionOptionsDistributionComponent } from './candidate-offer-evaluation-question-options-distribution/candidate-offer-evaluation-question-options-distribution.component';
import { CandidateOfferEvaluationQuestionResponsesComponent } from './candidate-offer-evaluation-question-responses/candidate-offer-evaluation-question-responses.component';
import { CandidateOfferEvaluationQuestionSkillsComponent } from './candidate-offer-evaluation-question-skills/candidate-offer-evaluation-question-skills.component';

@Component({
  selector: 'rt-candidate-offer-evaluation-question',
  templateUrl: './candidate-offer-evaluation-question.component.html',
  styleUrl: './candidate-offer-evaluation-question.component.less',
  imports: [
    BoxComponent,
    CandidateOfferEvaluationQuestionAttachmentsComponent,
    CandidateOfferEvaluationQuestionBooleanDistributionComponent,
    CandidateOfferEvaluationQuestionCommentsComponent,
    CandidateOfferEvaluationQuestionOptionsDistributionComponent,
    CandidateOfferEvaluationQuestionResponsesComponent,
    CandidateOfferEvaluationQuestionSkillsComponent,
  ],
})
export class CandidateOfferEvaluationQuestionComponent {
  protected readonly AggregateType = AggregatedEvaluationsQuestionAggregateType;

  public question = input.required<AggregatedEvaluationsQuestion>();

  public theme = input<Theme | null>(null);

  public useProsemirror = input(false);

  public showPositionButton = input(true);

  public viewPosition = output();
}
